/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
import { apiPost } from 'utils'
import { IMinibasic } from 'model'
import { XhhyRequest, XhhyResponse } from 'Xhhy-common/common'
  
  /**
   * 拉取基础信息
   * @param params
   */
  export const apiSelectMiniBasicInfo = async (params: XhhyRequest) => {
   return await apiPost<XhhyRequest, IMinibasic>(`/ticpocapi/minibasic/selectMiniBasicInfo`, params)
  }

  /**
   * 保存更改
   * @param params
   */
  export const apiSaveupdate = async (params: IMinibasic) => {
    return await apiPost<IMinibasic, XhhyResponse>(`/ticpocapi/minibasic/saveupdate`, params)
  }
  